import { render, staticRenderFns } from "./TheChat.vue?vue&type=template&id=dbd4b01e&scoped=true&"
import script from "./TheChat.vue?vue&type=script&lang=js&"
export * from "./TheChat.vue?vue&type=script&lang=js&"
import style0 from "./TheChat.vue?vue&type=style&index=0&id=dbd4b01e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd4b01e",
  null
  
)

export default component.exports